import Vue from 'vue'
import router from './router/router';
import App from './App.vue'
import Multilanguaje from 'vue-multilanguage';
import store from '../src/store';

router.afterEach( ()=>{
    setTimeout(function(){
        $("#loading").fadeOut(500);
    }, 2000);
});

import messages from '../src/translations';
import VueSweetAlert from 'vue-sweetalert';
import veeValidate from 'vee-validate';

Vue.use(VueSweetAlert);
Vue.use( Multilanguaje, messages );
Vue.use(veeValidate);

new Vue({
    store,
    router,
    el: '#app',
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js